export default __webpack_public_path__ + "static/media/DancingScript-Medium.c76ea376.ttf";